function getSelectedVariantParentSku(itemList, sku) {
  return itemList.filter(
    (item) => item.variants?.filter((vItem) => vItem.sku === sku).length
  )[0]?.sku;
}
export {
  getSelectedVariantParentSku
};
//# sourceMappingURL=get-selected-variant-parent-sku.js.map
